import { CookieTableCategories } from '../../config/types/codegen'
import { CONSENT_CATEGORY } from '../../config/types/consent'

/**
 * @description
 * Adds the current domain to the cookie table used for "autoclear cookies"
 * functionality, by the cookie consent banner. Should be only invoked in the
 * browser code, at runtime, as the domain gets retrieved from the browser.
 *
 * @param cookieTable the cookie table to add the domain to
 *
 * @returns the cookie table with the domain field added
 */

export function withDomain(cookieTable: CookieTableCategories) {
  const domain = getDomain(window.location.hostname)

  return Object.entries(cookieTable).reduce<CookieTableCategories>(
    (cookieTableWithDomain, [category, cookies]) => {
      cookieTableWithDomain[category as CONSENT_CATEGORY] = cookies.map(
        (cookie) => ({
          ...cookie,
          domain,
        }),
      )

      return cookieTableWithDomain
    },
    {},
  )
}

export function getDomain(hostname: string) {
  const [subdomain] = hostname.match(/.+(?=gousto\..+)/) || []

  return subdomain ? hostname.replace(subdomain, '') : hostname
}
